"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CookieHelper = void 0;
var cookie = document.cookie.split(';').reduce(function (accumulator, currentValue) {
    var _a = currentValue.split('='), key = _a[0], value = _a[1];
    accumulator[key.trim()] = value;
    accumulator[key.toLowerCase().trim()] = value;
    return accumulator;
}, {});
var CookieHelper = (function () {
    function CookieHelper() {
    }
    CookieHelper.get = function (key) { return cookie[key]; };
    CookieHelper.checkIsTrue = function (key) { return (cookie[key] || '').toLowerCase() === 'true'; };
    return CookieHelper;
}());
exports.CookieHelper = CookieHelper;



//////////////////
// WEBPACK FOOTER
// C:/WS/ls/build/player-application-workflow/src/shared/code/CookieHelper.ts
// module id = 154
// module chunks = 0 2